__turbopack_context__.v({
  "article": "ArticleView-module__X9ciIG__article",
  "author": "ArticleView-module__X9ciIG__author",
  "authorAvatar": "ArticleView-module__X9ciIG__authorAvatar",
  "authorInfo": "ArticleView-module__X9ciIG__authorInfo",
  "authorName": "ArticleView-module__X9ciIG__authorName",
  "authorRole": "ArticleView-module__X9ciIG__authorRole",
  "backButton": "ArticleView-module__X9ciIG__backButton",
  "backLink": "ArticleView-module__X9ciIG__backLink",
  "backSection": "ArticleView-module__X9ciIG__backSection",
  "breadcrumb": "ArticleView-module__X9ciIG__breadcrumb",
  "breadcrumbCurrent": "ArticleView-module__X9ciIG__breadcrumbCurrent",
  "breadcrumbLink": "ArticleView-module__X9ciIG__breadcrumbLink",
  "breadcrumbSeparator": "ArticleView-module__X9ciIG__breadcrumbSeparator",
  "carouselNavButton": "ArticleView-module__X9ciIG__carouselNavButton",
  "carouselNavButtonNext": "ArticleView-module__X9ciIG__carouselNavButtonNext",
  "carouselNavButtonPrev": "ArticleView-module__X9ciIG__carouselNavButtonPrev",
  "category": "ArticleView-module__X9ciIG__category",
  "content": "ArticleView-module__X9ciIG__content",
  "date": "ArticleView-module__X9ciIG__date",
  "dialogCaption": "ArticleView-module__X9ciIG__dialogCaption",
  "dialogCarousel": "ArticleView-module__X9ciIG__dialogCarousel",
  "dialogCarouselContainer": "ArticleView-module__X9ciIG__dialogCarouselContainer",
  "dialogCarouselSlide": "ArticleView-module__X9ciIG__dialogCarouselSlide",
  "dialogClose": "ArticleView-module__X9ciIG__dialogClose",
  "dialogContent": "ArticleView-module__X9ciIG__dialogContent",
  "dialogImage": "ArticleView-module__X9ciIG__dialogImage",
  "dialogImageContainer": "ArticleView-module__X9ciIG__dialogImageContainer",
  "dialogImageWrapper": "ArticleView-module__X9ciIG__dialogImageWrapper",
  "dialogOverlay": "ArticleView-module__X9ciIG__dialogOverlay",
  "galleryCaption": "ArticleView-module__X9ciIG__galleryCaption",
  "galleryContainer": "ArticleView-module__X9ciIG__galleryContainer",
  "galleryDialog": "ArticleView-module__X9ciIG__galleryDialog",
  "galleryDialogBackdropIn": "ArticleView-module__X9ciIG__galleryDialogBackdropIn",
  "galleryDialogCard": "ArticleView-module__X9ciIG__galleryDialogCard",
  "galleryDialogClose": "ArticleView-module__X9ciIG__galleryDialogClose",
  "galleryDialogDesc": "ArticleView-module__X9ciIG__galleryDialogDesc",
  "galleryDialogError": "ArticleView-module__X9ciIG__galleryDialogError",
  "galleryDialogFadeIn": "ArticleView-module__X9ciIG__galleryDialogFadeIn",
  "galleryDialogForm": "ArticleView-module__X9ciIG__galleryDialogForm",
  "galleryDialogHeader": "ArticleView-module__X9ciIG__galleryDialogHeader",
  "galleryDialogIcon": "ArticleView-module__X9ciIG__galleryDialogIcon",
  "galleryDialogInput": "ArticleView-module__X9ciIG__galleryDialogInput",
  "galleryDialogInputError": "ArticleView-module__X9ciIG__galleryDialogInputError",
  "galleryDialogMeta": "ArticleView-module__X9ciIG__galleryDialogMeta",
  "galleryDialogPanel": "ArticleView-module__X9ciIG__galleryDialogPanel",
  "galleryDialogPanelIn": "ArticleView-module__X9ciIG__galleryDialogPanelIn",
  "galleryDialogPwdWrap": "ArticleView-module__X9ciIG__galleryDialogPwdWrap",
  "galleryDialogSubmit": "ArticleView-module__X9ciIG__galleryDialogSubmit",
  "galleryDialogTitle": "ArticleView-module__X9ciIG__galleryDialogTitle",
  "galleryDialogToggle": "ArticleView-module__X9ciIG__galleryDialogToggle",
  "galleryGate": "ArticleView-module__X9ciIG__galleryGate",
  "galleryGateContent": "ArticleView-module__X9ciIG__galleryGateContent",
  "galleryGateLockBack": "ArticleView-module__X9ciIG__galleryGateLockBack",
  "galleryGateLockSvg": "ArticleView-module__X9ciIG__galleryGateLockSvg",
  "galleryGateLockWrap": "ArticleView-module__X9ciIG__galleryGateLockWrap",
  "galleryGateMessage": "ArticleView-module__X9ciIG__galleryGateMessage",
  "galleryGrid": "ArticleView-module__X9ciIG__galleryGrid",
  "galleryImage": "ArticleView-module__X9ciIG__galleryImage",
  "galleryItem": "ArticleView-module__X9ciIG__galleryItem",
  "gallerySection": "ArticleView-module__X9ciIG__gallerySection",
  "galleryTitle": "ArticleView-module__X9ciIG__galleryTitle",
  "gradientOrb1": "ArticleView-module__X9ciIG__gradientOrb1",
  "hero": "ArticleView-module__X9ciIG__hero",
  "heroBackground": "ArticleView-module__X9ciIG__heroBackground",
  "heroContent": "ArticleView-module__X9ciIG__heroContent",
  "image": "ArticleView-module__X9ciIG__image",
  "imageCaption": "ArticleView-module__X9ciIG__imageCaption",
  "imageContainer": "ArticleView-module__X9ciIG__imageContainer",
  "imageSection": "ArticleView-module__X9ciIG__imageSection",
  "main": "ArticleView-module__X9ciIG__main",
  "meta": "ArticleView-module__X9ciIG__meta",
  "metaDivider": "ArticleView-module__X9ciIG__metaDivider",
  "notFound": "ArticleView-module__X9ciIG__notFound",
  "podcast": "ArticleView-module__X9ciIG__podcast",
  "podcastWrapper": "ArticleView-module__X9ciIG__podcastWrapper",
  "readTime": "ArticleView-module__X9ciIG__readTime",
  "title": "ArticleView-module__X9ciIG__title",
  "video": "ArticleView-module__X9ciIG__video",
  "videoWrapper": "ArticleView-module__X9ciIG__videoWrapper",
});
